/**
 * subscriptionGate — espelho visual da política de acesso do backend.
 *
 * Puramente funcional (sem I/O) pra ser testável e reusável. Os componentes
 * (SubscriptionBlockScreen / OverdueDailyDialog) e o AppLayout consomem o
 * resultado. O backend continua sendo a autoridade e pode bloquear qualquer
 * chamada paga com 402 mesmo que este retrato local esteja desatualizado.
 */

export const DIAS_ATE_BLOQUEIO = 7;
const DIA_MS = 24 * 60 * 60 * 1000;

export interface SubscriptionGate {
  /** Dias inteiros desde que ficou past_due (>=0), ou null se não se aplica. */
  diasAtrasado: number | null;
  /** true → cobrir o app com a tela de bloqueio total. */
  bloqueado: boolean;
  /** true → mostrar o pop-up diário de aviso (past_due, ainda não bloqueado). */
  mostrarAvisoDiario: boolean;
}

const VAZIO: SubscriptionGate = {
  diasAtrasado: null,
  bloqueado: false,
  mostrarAvisoDiario: false,
};

const BLOQUEADO_PARA_RECUPERACAO: SubscriptionGate = {
  diasAtrasado: null,
  bloqueado: true,
  mostrarAvisoDiario: false,
};

export function computeSubscriptionGate(params: {
  status: string | null;
  /** ISO timestamp de quando ficou past_due (backend), ou null. */
  pastDueSince: string | null;
  /** epoch ms; default Date.now() (injetável pra teste). */
  now?: number;
}): SubscriptionGate {
  const { status, pastDueSince } = params;
  const now = params.now ?? Date.now();

  if (status === "active" || status === "trialing") return VAZIO;
  if (status !== "past_due") return BLOQUEADO_PARA_RECUPERACAO;
  if (!pastDueSince) return BLOQUEADO_PARA_RECUPERACAO;

  const since = new Date(pastDueSince).getTime();
  if (Number.isNaN(since) || since > now) return BLOQUEADO_PARA_RECUPERACAO;

  const diasAtrasado = Math.floor((now - since) / DIA_MS);
  const bloqueado = diasAtrasado >= DIAS_ATE_BLOQUEIO;

  return {
    diasAtrasado,
    bloqueado,
    mostrarAvisoDiario: !bloqueado, // dias 0-6 avisam; a partir do 7 bloqueia
  };
}
